import * as React from "react";
import { motion } from "framer-motion";
const Path = (props: any) => (
  <motion.path
    fill="transparent"
    strokeWidth="2"
    stroke={props.isOpen ? "#220859" : "#fff"}
    strokeLinecap="round"
    {...props}
  />
);
export type MenuTogglePropsType = {
  isOpen: boolean;
};
export const MenuToggle = ({ isOpen }: MenuTogglePropsType) => {
  return (
    <svg width="45" height="32" viewBox="0 0 23 23">
      <Path
        variants={{
          closed: { d: "M 2 2.5 L 20 2.5" },
          open: { d: "M 7 7 L 16 16" },
        }}
        isOpen={isOpen}
      />
      <Path
        d="M -2 11 L 24 11"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 },
        }}
        transition={{ duration: 0.3 }}
        isOpen={isOpen}
      />{" "}
      <Path
        isOpen={isOpen}
        variants={{
          closed: { d: "M 2 19.5 L 20 19.5" },
          open: { d: "M 7 16 L 16 7" },
        }}
      />
    </svg>
  );
};
